import React from 'react';

import { Box } from '@components/Restyle';
import { Skeleton } from '@components/shared/Skeleton';
import { ContactRowSkeleton } from '@components/shared/skeletons/ContactRowSkeleton';
import { SkeletonList } from '@components/shared/skeletons/SkeletonList';

const renderContactRowSkeleton = () => <ContactRowSkeleton />;

/**
 * TA-10276: Contact list / Group list placeholder — 3 alphabet-header bands,
 * each followed by 3 `ContactRowSkeleton` rows, per the Figma "3 skeleton
 * rows under each alphabet header on mount" note. Shared by both the
 * Contacts tab and the Group tab (both render the same header + row shape).
 */
export const ContactListSkeleton: React.FC<{ testID?: string }> = ({
  testID = 'contact-list-skeleton',
}) => {
  return (
    <Box testID={testID}>
      {Array.from({ length: 3 }, (_, index) => (
        <Box key={index}>
          <Box backgroundColor='grey01' paddingVertical='xs' paddingLeft='m'>
            <Skeleton variant='text' width={16} height={12} />
          </Box>
          <SkeletonList row={renderContactRowSkeleton} />
        </Box>
      ))}
    </Box>
  );
};
